import { copyToClipboard } from '@uikit/helpers/copyToClipboard';
import clsx from 'clsx';
import React from 'react';
import BaseToolTip from '../BaseToolTip/BaseToolTip';
import BaseToolTipMobile from '../BaseToolTip/BaseToolTipMobile/BaseToolTipMobile';
import Icon from '../Icon/Icon';
import type {
  PromocodeButtonContentProps,
  PromocodeButtonProps,
} from './interfaces';
import styles from './PromocodeButton.module.scss';

const MAX_CHARACTERS = 18;

const PromocodeButtonContent = ({
  label = 'Gutschein anzeigen',
  revealedLabel,
  onClick,
  size,
  state,
  showCopyIcon,
  onMouseLeave,
  onMouseEnter,
  setIsCopied,
  setWasCopied,
}: PromocodeButtonContentProps) => {
  const handleClick = () => {
    if (state === 'activated' && showCopyIcon) {
      setIsCopied(true);
      copyToClipboard(revealedLabel);

      setTimeout(() => {
        setWasCopied(true);
      }, 1500);

      setTimeout(() => {
        setIsCopied(false);
      }, 2500);
      return;
    }

    if (state !== 'disabled') {
      onClick();
    }
  };

  const handleMouseEnter = () => {
    if (state === 'activated' && showCopyIcon) {
      onMouseEnter?.();
    }
  };

  const handleMouseLeave = () => {
    if (state === 'activated' && showCopyIcon) {
      onMouseLeave?.();
      setWasCopied(false);
    }
  };

  const showIcon = state !== 'disabled' && showCopyIcon;
  const hasSmallerFontSize = revealedLabel.length >= MAX_CHARACTERS;

  return (
    <div
      onClick={handleClick}
      className={clsx(styles.base, styles[size], {
        [styles.peeled]: state === 'activated' || state === 'disabled',
        [styles.loading]: state === 'loading',
        [styles.disabled]: state === 'disabled',
        [styles.withCopyIcon]: showIcon,
      })}
    >
      <div
        className={clsx(styles.back, {
          [styles.smallerText]: hasSmallerFontSize,
        })}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {revealedLabel}
        {showIcon && <Icon size="iconSize20" variant="action/copy" />}
      </div>

      <div className={styles.front} data-text={label} />
    </div>
  );
};

const PromocodeButton = ({ ...props }: PromocodeButtonProps) => {
  const [isCopied, setIsCopied] = React.useState(false);
  const [wasCopied, setWasCopied] = React.useState(false);

  return (
    <BaseToolTip
      title={isCopied ? 'Kopiert!' : 'Code kopieren'}
      variant={isCopied ? 'highlight' : 'default'}
      showTooltip={!wasCopied}
      mobileComponentSlot={
        <BaseToolTipMobile isVisible={isCopied}>Kopiert!</BaseToolTipMobile>
      }
    >
      <PromocodeButtonContent
        setIsCopied={setIsCopied}
        setWasCopied={setWasCopied}
        {...props}
      />
    </BaseToolTip>
  );
};

export default PromocodeButton;
